import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from './user-settings.model';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private url: string = environment.serverUrl;

  constructor(private http: HttpClient) {}

  postUser(user: User): Observable<any> {
    return this.http.post(this.url + 'users/', user);
  }

  putUser(user: User): Observable<any> {
    return this.http.put(this.url + 'users/', user);
  }

  deleteUser(index: number): Observable<any> {
    return this.http.delete(this.url + 'users/' + index);
  }

  fetchUsers(): Observable<any> {
    return this.http.get(this.url + 'users/');
  }

  fetchRoles():Observable<any>{
    return this.http.get(this.url + 'roles');
  }
}
